import React, { useEffect } from "react";
import "./Gold.css";
import { openWhatsApp } from "../utils/whatsapp";

// ===== Import Gold Jewelry Images =====
import goldE1 from "../Assets/goldE1.jpg";
import goldE2 from "../Assets/goldE2.jpg";
import goldE3 from "../Assets/goldE3.jpg";
import goldE4 from "../Assets/goldE4.jpg";
import goldE5 from "../Assets/goldE6.jpg";
import goldE6 from "../Assets/goldE5.jpg";

import goldR1 from "../Assets/goldR1.jpeg";
import goldR2 from "../Assets/goldR2.jpg";
import goldR3 from "../Assets/goldR3.jpg";
import goldR4 from "../Assets/goldR4.jpg";
import goldR5 from "../Assets/goldR5.jpg";
import goldR6 from "../Assets/goldR6.jpg";

import goldP1 from "../Assets/goldP1.jpg";
import goldP2 from "../Assets/goldP3.jpg";
import goldP3 from "../Assets/goldP2.jpg";
import goldP4 from "../Assets/goldP4.jpg";
import goldP5 from "../Assets/goldP6.jpg";
import goldP6 from "../Assets/goldP5.jpg";

import goldA1 from "../Assets/goldA1.jpg";
import goldA2 from "../Assets/goldA2.jpg";
import goldA3 from "../Assets/goldA3.jpg";
import goldA4 from "../Assets/goldA4.jpg";
import goldA5 from "../Assets/goldA5.jpg";
import goldA6 from "../Assets/goldA6.jpg";

import goldC1 from "../Assets/goldC1.jpg";
import goldC2 from "../Assets/goldC2.jpg";
import goldC3 from "../Assets/goldC3.jpg";
import goldC4 from "../Assets/goldC4.jpg";
import goldC5 from "../Assets/goldC5.jpg";
import goldC6 from "../Assets/goldC6.jpg";

import goldB1 from "../Assets/goldB1.jpg";
import goldB2 from "../Assets/goldB2.jpg";
import goldB3 from "../Assets/goldB3.jpg";
import goldB4 from "../Assets/goldB4.webp";
import goldB5 from "../Assets/goldB5.jpg";
import goldB6 from "../Assets/goldB6.webp";

import goldBanner from "../Assets/goldBanner1.jpg";

const categories = [
    { id: "gold-earrings", title: "Earrings", images: [goldE1, goldE2, goldE3, goldE4, goldE5, goldE6] },
    { id: "gold-rings", title: "Rings", images: [goldR1, goldR2, goldR3, goldR4, goldR5, goldR6] },
    { id: "gold-pendant", title: "Pendant", images: [goldP1, goldP2, goldP3, goldP4, goldP5, goldP6] },
    { id: "gold-anklet", title: "Anklet", images: [goldA1, goldA2, goldA3, goldA4, goldA5, goldA6] },
    { id: "gold-necklace-chain", title: "Necklace & Chain", images: [goldC1, goldC2, goldC3, goldC4, goldC5, goldC6] },
    { id: "gold-bracelet", title: "Bracelet", images: [goldB1, goldB2, goldB3, goldB4, goldB5, goldB6] },
];

const Gold = () => {
    // Smooth scroll to section when page loads with hash
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 100);
            }
        }
    }, []);

    return (
        <div className="gold-page">
            {/* 🌟 Hero Section */}
            <section className="gold-hero" id="top">
                <img src={goldBanner} alt="Gold Collection" className="gold-hero-img" />
                <div className="gold-hero-overlay">
                    <div className="gold-hero-card">
                        <h1>Gold Collection</h1>
                    </div>
                </div>
            </section>

            {/* 💎 Each Category Section */}
            {categories.map((category, categoryIndex) => (
                <section className="gold-section" key={categoryIndex} id={category.id}>
                    <h2 className="gold-title">{category.title}</h2>
                    <hr className="gold-line" />

                    <div className="gold-grid">
                        {category.images.map((img, imgIndex) => {
                            const itemNumber = categoryIndex * 6 + imgIndex + 1;
                            const itemCode = `G${itemNumber.toString().padStart(2, '0')}`;
                            return (
                                <div className="gold-card" key={imgIndex}>
                                    <img src={img} alt={`${category.title} ${imgIndex + 1}`} />
                                    <span>Item code: {itemCode}</span>
                                    <button onClick={() => openWhatsApp(itemCode)}>
                                        Inquire Now
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default Gold;